import React, { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import staticGamesData from "../../assets/static.json";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import { useDispatch, useSelector } from "react-redux";
import { getSearchResults, setSearchInput } from "../crashGames/cl_CrashSlice";
import { setIsVipSearchBoxOpen } from "../signIn/cl_SignInSlice";
import {
  gamesSelectedList,
  generateAffiliate,
  getUpdatedGamesList,
  setSelectedGamesList,
  generateVIPReport,
  setUserNameErrMsg,
  setDisplayPopup,
  setViewAllModal,
} from "../home/cl_LoyalltyCoins";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../services/helper/cl_Helper";
import Modal_verify from "./Modal_verify";
import { Link, useNavigate } from "react-router-dom";
import ViewAllModal from "./ViewAllModal";
import statickImg from "../../assets/images/popup/staticImg.webp";

export const Affliliate_site = () => {
  const { IsVipSearchBoxOpen, userDetails } = useSelector(
    (state) => state?.signIn
  );
  const { searchInput, filteredGames } = useSelector((state) => state?.crash);
  const {
    affiliateRes,
    selectedGamesList,
    updatedGamesList,
    successMsg,
    selectedUserName,
    userNameErrMsg,
    viewAllModal,
    affiliatesData,
    loader,
  } = useSelector((state) => state?.coinsHistory);
  const { affiliateCode, searchUserName } = useSelector(
    (state) => state?.signUp
  );

  const [vipnameSuccess, setVipnameSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editGames, setEditGames] = useState(false);
  const [combinedgGames, setCombinedGames] = useState([]);
  const [gamesMaxLimit, setGamesMaxLimit] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [userName, setUserName] = useState("");
  const [noGamesSelectedMsg, setNoGamesSelectedMsg] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [isNativeApp, setIsNativeApp] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getFromLocalStorage("gk");
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile =
    /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

  // Detect if running in native app (Median)
  const isMedianNativeApp = () => {
    return !!(
      window.AndroidInterface ||
      (window.webkit && window.webkit.messageHandlers) ||
      window.MedianNativeApp ||
      window.gonative ||
      isMobile ||
      navigator.userAgent.includes("Median") ||
      navigator.userAgent.includes("medianNativeApp")
    );
  };

  useEffect(() => {
    const combinedData = staticGamesData?.categories?.reduce(
      (acc, category) => {
        return acc.concat(category?.games);
      },
      []
    );
    setCombinedGames(combinedData);
    dispatch(setSearchInput(""));
  }, []);

  useEffect(() => {
    setIsNativeApp(isMedianNativeApp());
  }, []);

  useEffect(() => {
    dispatch(getSearchResults(combinedgGames, searchInput));
  }, [searchInput, combinedgGames]);

  useEffect(() => {
    if (userDetails?.userId && !affiliateCode) {
      dispatch(generateAffiliate(userDetails));
    }
    dispatch(setIsVipSearchBoxOpen(false));
    dispatch(setUserNameErrMsg(""));
  }, [userDetails?.userId]);

  useEffect(() => {
    if (affiliateCode) {
      setToLocalStorage("ac", affiliateCode);
      dispatch(
        gamesSelectedList(userDetails?.userId, affiliateCode, searchUserName)
      );
      if (token) dispatch(generateVIPReport(affiliateCode, token));
    }
  }, [affiliateCode]);

  useEffect(() => {
    if (userDetails?.userId && !affiliateCode) {
      dispatch(gamesSelectedList(userDetails.userId, "", ""));
      if (token) dispatch(generateVIPReport(affiliateCode, token));
    }
  }, [userDetails?.userId, affiliateCode]);

  useEffect(() => {
    if (affiliateRes?.btag) {
      dispatch(
        getUpdatedGamesList(
          userDetails?.userId,
          affiliateRes?.btag,
          selectedGamesList || [],
          "init",
          userName
        )
      );
    }
  }, [affiliateRes]);

  useEffect(() => {
    if (selectedUserName) setUserName(selectedUserName);
  }, [selectedUserName]);

  useEffect(() => {
    let newMessage = "";
    if (vipnameSuccess && !successMsg && userNameErrMsg?.length < 0) {
      newMessage = "Your Referral site has been created successfully";
    } else if (vipnameSuccess && successMsg) {
      newMessage = `Your Referral site has been created successfully${selectedGamesList?.length > 0
        ? `\nYour ${selectedGamesList.length} selected game(s) have been saved successfully`
        : ""
        }`;
    } else if (!vipnameSuccess && successMsg) {
      newMessage = `Your ${selectedGamesList?.length} selected game(s) have been saved successfully`;
    }
    setMessage(newMessage);
    if (newMessage) setShowModal(true);
  }, [selectedGamesList, vipnameSuccess, successMsg, userNameErrMsg]);

  const handleSearchData = (event) => {
    dispatch(setSearchInput(event.target.value));
  };

  const toggleSelection = (e, game) => {
    const gameWithAggregator = {
      ...game,
      aggregator: game.aggregator_type || game.aggregator || "",
    };
    const activeGames = selectedGamesList.filter(({ active }) => active);

    if (
      selectedGamesList.some(
        (selectedGame) =>
          selectedGame.game_code === game.game_code ||
          selectedGame.gameCode === game.game_code
      )
    ) {
      const updatedGames = selectedGamesList.map((selectedGame) =>
        selectedGame.game_code === game.game_code ||
          selectedGame.gameCode === game.game_code
          ? { ...selectedGame, active: !selectedGame.active }
          : selectedGame
      );
      dispatch(setSelectedGamesList(updatedGames));
    } else if (activeGames.length < 5) {
      dispatch(
        setSelectedGamesList([
          ...selectedGamesList,
          { ...gameWithAggregator, active: true },
        ])
      );
    } else {
      setGamesMaxLimit(true);
      setTimeout(() => setGamesMaxLimit(false), 2000);
    }
  };

  const toggleUpdateSelection = (game, index) => {
    const updatedSelectedGamesList = selectedGamesList.map((gamedata, ind) => {
      if (ind === index) {
        return {
          ...gamedata,
          active: !gamedata.active,
          aggregator: gamedata.aggregator || gamedata.aggregator_type || "",
        };
      }
      return gamedata;
    });
    dispatch(setSelectedGamesList(updatedSelectedGamesList));
  };

  const editGameSelection = () => {
    const updatedList = selectedGamesList.map((selectedGame) => ({
      ...selectedGame,
      active: true,
      aggregator: selectedGame.aggregator || selectedGame.aggregator_type || "",
    }));
    setIsUpdate(true);
    setEditGames(true);
    dispatch(setSelectedGamesList(updatedList));
  };

  const getDisplayText = () => {
    return `Fasfasgames${selectedUserName || userName ? `/${selectedUserName || userName}` : ""
      }`;
  };

  const getReferralUrl = () => {
    return `${process.env.REACT_APP_FASFASREFERURL}/signup/?afid=${affiliateCode}`;
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText("Copied");
      setTimeout(() => setCopiedText(""), 2000);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopiedText("Copied");
      setTimeout(() => setCopiedText(""), 2000);
    }
  };

  const handleSave = () => {
    const totalRefferalGames = selectedGamesList?.filter(
      ({ active }) => active === true
    );

    if (totalRefferalGames?.length === 0) {
      setNoGamesSelectedMsg(true);
      setTimeout(() => setNoGamesSelectedMsg(false), 3000);
      return;
    }

    if (totalRefferalGames?.length > 5) {
      setGamesMaxLimit(true);
      setTimeout(() => setGamesMaxLimit(false), 2000);
      return;
    }

    if (!userName) {
      return dispatch(setUserNameErrMsg("Please enter your VIP name"));
    }

    if (userName.length < 4 || userName.length > 12) {
      return dispatch(
        setUserNameErrMsg(
          "Please choose a name between 4 to 12 characters in length."
        )
      );
    }

    if (!/^[a-zA-Z0-9]+$/.test(userName)) {
      return dispatch(
        setUserNameErrMsg(
          "Please choose a name that only contains alphanumeric characters (letters and numbers)."
        )
      );
    }

    dispatch(setDisplayPopup(true));
    setGamesMaxLimit(false);
    setVipnameSuccess(true);

    dispatch(
      getUpdatedGamesList(
        userDetails?.userId,
        affiliateCode,
        selectedGamesList,
        "",
        userName
      )
    );

    dispatch(setIsVipSearchBoxOpen(false));
    setIsUpdate(false);
  };

  const handleKeyDown = (event) => {
    const regex = /^[a-zA-Z0-9]$/;
    const controlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
    ];
    if (!regex.test(event.key) && !controlKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleNameInput = (e) => {
    setUserName(e.target.value);
    dispatch(setUserNameErrMsg(""));
  };

  const linkmode = () => {
    window.open(getReferralUrl(), "_blank");
  };

  return (
    <>
      {showModal && message && <Modal_verify title={message} />}

      <div className="SB-myAccount-sectionBox SB-loyalty-affiliate">
        <div className="SB-myAccount-sectionBox_content">
          <div className="SB-loyalty-affiliateName">
            {loader ? (
              <div className="SB-section-loader">
                <div className="dots-loader"></div>
              </div>
            ) : !selectedUserName ? (
              <div className="SB-form-group">
                <div className="SB-form-label">
                  <span>Enter Your Name</span>
                </div>
                <div className="SB-form-control SB-error">
                  <input
                    type="text"
                    value={userName}
                    placeholder="Enter Your Name Here"
                    onChange={handleNameInput}
                    maxLength={12}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="SB-btnContainer">
                  <button
                    className="btn SB-btnSecondary active SB-btneditGames"
                    onClick={handleSave}
                    disabled={!userName || userName.length < 4}
                  >
                    Save
                  </button>
                </div>
                <div className="SB-form-errorMsg">
                  <span>{userNameErrMsg}</span>
                </div>
              </div>
            ) : (
              <div className="SB-loyalty-affiliate-registeredName">
                <p>
                  Your BOSS Name: <b>{selectedUserName}</b>
                </p>
              </div>
            )}
          </div>

          <div className="SB-loyalty-affiliateSite">
            <div className="SB-affiliateSite-title">Your Referral Site</div>
            <div className="SB-affiliateSite-details">
              <div className="SB-affiliateSite-link">
                <div className="SB-iconSVG">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#icon-link`} />
                  </svg>
                  <span onClick={linkmode}>{getDisplayText()}</span>
                </div>
              </div>

              {selectedUserName && (
                <div className="SB-affiliate-icons">
                  {!isNativeApp && (
                    <div className="SB-iconSVG">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-share`} />
                      </svg>
                    </div>
                  )}
                  <div className="SB-affiliate-copy">
                    <div
                      className="SB-iconSVG"
                      onClick={() => copyToClipboard(getReferralUrl())}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-copy`} />
                      </svg>
                    </div>
                    <span>{copiedText}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Description */}
          <div className="SB-affiliate-discription">
            <p>
              Earn a cashback via your referrals.{" "}
              <Link to="/terms-conditions" style={{ color: "var(--color-highlight)" }}>
                <b>T&C</b>
              </Link>{" "}
              Apply.
            </p>
          </div>

          {/* Stats Section */}
          <div className="SB-signupUsers">
            <div className="SB-usersCount">
              <div className="SB-countBox">
                <div className="SB-countBox-header">No. of Players</div>
                <div className="SB-countBox-value">
                  {affiliatesData?.totalSignups || 0}
                </div>
              </div>
              <div className="SB-countBox">
                <div className="SB-countBox-header">
                  Lifetime cashback earned
                </div>
                <div className="SB-countBox-value">
                  {affiliatesData?.totalEarnings
                    ? affiliatesData.totalEarnings.toFixed(2)
                    : 0}
                </div>
              </div>
              <div className="SB-countBox">
                <div className="SB-countBox-header">Available cashback</div>
                <div className="SB-countBox-value">
                  {affiliatesData?.availableEarnings
                    ? affiliatesData.availableEarnings.toFixed(2)
                    : 0}
                </div>
              </div>
            </div>
            <div className="SB-btnContainer SB-btnContainer-viewall">
              <button
                className="btn SB-btnSecondary active SB-btnView-all"
                onClick={() =>
                  navigate("/all-earnings", { state: { affiliateCode: affiliateCode } })
                }
              >
                View all Earnings
              </button>
            </div>
          </div>

          {/* Error Messages */}
          {gamesMaxLimit && (
            <div className="SB-msgBox SB-error">
              <div className="SB-msgBox-container">
                <div className="SB-iconSVG">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#icon-alert`} />
                  </svg>
                </div>
                Oops! Max limit reached. Please unselect any game to select a
                new one.
              </div>
            </div>
          )}

          {/* Games Selection */}
          <div className="SB-selectGames">
            {noGamesSelectedMsg &&
              selectedGamesList?.length === 0 &&
              !IsVipSearchBoxOpen && (
                <div className="SB-msgBox SB-error">
                  <div className="SB-msgBox-container">
                    <div className="SB-iconSVG">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-alert`} />
                      </svg>
                    </div>
                    No games selected yet. You can select up to 5 games for your
                    referral site.
                  </div>
                </div>
              )}

            <div className="SB-selectGames-header">
              <div className="SB-myAccount-sectionBox_header">
                <span className="SB-selectGames-label">
                  {selectedGamesList?.length > 0 ? (
                    <b>
                      Selected Games
                      {!isUpdate
                        ? ""
                        : `(${updatedGamesList
                          ? selectedGamesList?.filter(
                            ({ active }) => active === true
                          ).length
                          : selectedGamesList?.length
                        })`}
                    </b>
                  ) : (
                    "You can select games up to 5"
                  )}
                </span>
              </div>
              <div className="SB-myAccount-sectionBox-icons">
                {setEditGames && !(updatedGamesList && !isUpdate) ? (
                  <div
                    className="SB-viewAll-games"
                    onClick={() => dispatch(setViewAllModal(true))}
                  >
                    View All
                  </div>
                ) : null}
              </div>
            </div>

            {/* Search Box */}
            {IsVipSearchBoxOpen && (
              <div className="SB-gamesSearch">
                <div className="SB-searchBox-container">
                  <div className="SB-searchBox">
                    <input
                      type="text"
                      id="SB-inputField"
                      placeholder="Search"
                      autoComplete="off"
                      onChange={handleSearchData}
                      value={searchInput}
                    />
                    {searchInput?.length > 0 ? (
                      <div
                        className="SB-searchClear"
                        onClick={() => dispatch(setSearchInput(""))}
                      >
                        <div className="SB-iconSVG">
                          <svg xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref={`${icons}#icon-back-delete`} />
                          </svg>
                        </div>
                      </div>
                    ) : (
                      <div className="SB-searchButton">
                        <div className="SB-iconSVG">
                          <svg xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref={`${icons}#icon-search`} />
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>

                  {searchInput !== "" && (
                    <div className="SB-searchResultBox">
                      {filteredGames?.length > 0 ? (
                        <ul>
                          {filteredGames?.map((game, index) => (
                            <li key={index}>
                              <div className="SB-form-group">
                                <div className="SB-checkbox">
                                  <input
                                    id={`checkbox-${game.name}-${index}`}
                                    name={game.name}
                                    value={game.active}
                                    type="checkbox"
                                    onChange={(e) => toggleSelection(e, game)}
                                    checked={selectedGamesList.some(
                                      (selectedGame) =>
                                        selectedGame.name === game.name &&
                                        selectedGame.active
                                    )}
                                  />
                                  <label
                                    htmlFor={`checkbox-${game.name}-${index}`}
                                  />
                                </div>
                                <div className="SB-searchResultItem">
                                  <div className="SB-icon-container">
                                    <img
                                      src={
                                        (game?.image?.configurl ||
                                          game?.image?.url) === "NoIcon"
                                          ? statickImg
                                          : game?.image?.configurl ||
                                          game?.image?.url ||
                                          statickImg
                                      }
                                      loading="lazy"
                                      onError={(e) => {
                                        e.target.src = statickImg;
                                      }}
                                      alt={game?.name}
                                    />
                                  </div>
                                  <div className="SB-searchResult-container">
                                    <div className="SB-searchResult-header">
                                      {game?.name}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="SB-msgBox">
                          <div className="SB-msgBox-container">
                            No results found
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Games List */}
            {updatedGamesList ? (
              <Splide
                className="SB-splide-games SB-gamesList SB-selectgamesList is-initialized is-active"
                hasTrack={false}
                options={{
                  type: "slide",
                  pagination: false,
                  autoplay: true,
                  autoWidth: true,
                  arrows: false,
                  lazyLoad: "sequential",
                }}
              >
                <SplideTrack>
                  {Array.isArray(selectedGamesList) &&
                    selectedGamesList.map((game, index) => (
                      <SplideSlide
                        key={index}
                        className={game.active ? "active" : ""}
                      >
                        <div
                          className="SB-gameItem"
                          onClick={() => {
                            if (isUpdate) {
                              toggleUpdateSelection(game, index);
                            }
                          }}
                        >
                          <img
                            src={
                              (game?.image?.configurl || game?.image?.url) ===
                                "NoIcon"
                                ? statickImg
                                : game?.image?.configurl ||
                                game?.image?.url ||
                                statickImg
                            }
                            loading="lazy"
                            onError={(e) => {
                              e.target.src = statickImg;
                            }}
                            alt={game?.name}
                          />
                          <div className="SB-gameTitle">{game?.name}</div>
                        </div>
                      </SplideSlide>
                    ))}
                </SplideTrack>
              </Splide>
            ) : (
              <Splide
                className="SB-splide-games SB-gamesList SB-selectgamesList is-initialized is-active"
                hasTrack={false}
                options={{
                  type: "slide",
                  pagination: false,
                  autoplay: true,
                  autoWidth: true,
                  arrows: false,
                  lazyLoad: "sequential",
                }}
              >
                <SplideTrack>
                  {selectedGamesList?.map((game, index) => (
                    <SplideSlide
                      key={index}
                      className={`${game.active ? "active" : ""}`}
                    >
                      <div
                        className="SB-gameItem"
                        onClick={(e) => {
                          toggleSelection(e, game, index);
                        }}
                      >
                        <img
                          src={
                            (game?.image?.configurl || game?.image?.url) ===
                              "NoIcon"
                              ? statickImg
                              : game?.image?.configurl ||
                              game?.image?.url ||
                              statickImg
                          }
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = statickImg;
                          }}
                          alt={game?.name}
                        />
                        <div className="SB-gameTitle">{game?.name}</div>
                      </div>
                    </SplideSlide>
                  ))}
                </SplideTrack>
              </Splide>
            )}

            {/* Action Buttons */}
            {updatedGamesList && !isUpdate ? (
              <div className="SB-btnContainer">
                <button
                  className="btn SB-btnSecondary active SB-btnSave"
                  onClick={() => {
                    editGameSelection(true);
                  }}
                >
                  Edit Games
                </button>
              </div>
            ) : (
              <div className="SB-btnContainer">
                <button
                  className="btn SB-btnSecondary active SB-btneditGames"
                  onClick={handleSave}
                >
                  Save
                </button>
              </div>
            )}
          </div>

          {viewAllModal && (
            <ViewAllModal selectedGamesList={selectedGamesList} />
          )}
        </div>
      </div>
    </>
  );
};
